import { api } from '../api';

export const downloadDocumentFromUserArchiveByReviewer: (ownerId: number, documentId: number) => Promise<void> = (
  ownerId: number, documentId: number
): Promise<void> => api.get(
  `/archive-administration/users/${ownerId}/documents/${documentId}/download`, { responseType: 'blob' }
);

export const downloadFileFromUserArchiveByReviewer: (
  ownerId: number, documentId: number, fileId: number
) => Promise<void> = (
  ownerId: number, documentId: number, fileId: number
): Promise<void> => api.get(
  `/archive-administration/users/${ownerId}/documents/${documentId}/files/${fileId}/download`, { responseType: 'blob' }
);
